const my_profile = {
  viewMyClubSeacretProfile: "Peržiūrėti mano ClubSeacret profilį", // translated 
  viewMoreDetails: "Žiūrėti daugiau informacijos", // translated 
  verifiedEmail: "Patvirtintas el", // translated 
  unverifiedEmail: "Nepatvirtintas el", // translated 
  balance: "Balansas", // translated 
  pointsIn: "Taškai į", // translated 
  pointsOut: "Atkreipia dėmesį į", // translated 
  topUp: "Prisipilti", // translated 
  pointsHistoryTable: "Taškų istorijos lentelė", // translated 
};


export default my_profile;
